if (!customElements.get("variant-selects")) {
    class e extends HTMLElement {
        constructor() {
            super(),
                (this.sticky = this.dataset.sticky),
                (this.updateUrl = "true" === this.dataset.updateUrl),
                (this.isDisabledFeature = this.dataset.isDisabled),
                this.addEventListener("change", this.onVariantChange),
                (this.other = Array.from(document.querySelectorAll("variant-selects")).filter((e) => e != this)),
                (this.productWrapper = this.closest(".thb-product-detail")),
                this.productWrapper && ((this.productSlider = this.productWrapper.querySelector(`#MediaGallery-${this.dataset.section}`)), this.productSlider && (this.hideVariants = "true" === this.productSlider.dataset.hideVariants));
        }
        connectedCallback() {
            this.updateOptions(), this.updateMasterId(), this.setDisabled(), this.setImageSet();
        }
        onVariantChange() {
            this.updateOptions(),
                this.updateMasterId(),
                this.toggleAddButton(!0, "", !1),
                this.updatePickupAvailability(),
                this.removeErrorMessage(),
                this.updateVariantText(),
                this.setDisabled(),
                this.currentVariant ? (this.updateMedia(), this.updateUrl && this.updateURL(), this.updateVariantInput(), this.renderProductInfo()) : (this.toggleAddButton(!0, "", !0), this.setUnavailable()),
                this.updateOther(),
                dispatchCustomEvent("product:variant-change", { variant: this.currentVariant, sectionId: this.dataset.section });
        }
        updateOptions() {
            (this.fieldsets = Array.from(this.querySelectorAll("fieldset"))),
                (this.options = []),
                (this.option_keys = []),
                this.fieldsets.forEach((e, t) => {
                    e.querySelector("select")
                        ? (this.options.push(e.querySelector("select").value), this.option_keys.push(e.querySelector("select").name))
                        : e.querySelectorAll("input").length && (this.options.push(e.querySelector("input:checked").value), this.option_keys.push(e.querySelector("input").name));
                });
        }
        updateVariantText() {
            Array.from(this.querySelectorAll("fieldset")).forEach((e, t) => {
                let i = e.querySelector(".form__label__value");
                i && (i.innerHTML = this.options[t]);
            });
        }
        updateMasterId() {
            this.currentVariant = this.getVariantData().find((e) => !e.options.map((e, t) => this.options[t] === e).includes(!1));
        }
        updateOther() {
            if ("false" !== this.dataset.updateUrl && this.other.length) {
                let e = this.other[0].querySelectorAll("fieldset"),
                    t = Array.from(e);
                this.options.forEach((e, i) => {
                    t[i].querySelector("select") ? (t[i].querySelector("select").value = e) : t[i].querySelectorAll("input").length && (t[i].querySelector(`input[value="${e}"]`).checked = !0);
                }),
                    this.other[0].updateOptions(),
                    this.other[0].updateMasterId(),
                    this.other[0].updateVariantText(),
                    this.other[0].setDisabled(),
                    this.other[0].setImageSetMedia();
            }
        }
        updateMedia() {
            if (!this.currentVariant) return;
            if (!this.currentVariant.featured_media) return;
            if (!this.productSlider) return;
            let e = `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
                t = this.productSlider.querySelector(`[data-media-id="${e}"]`);
            this.productSlider.querySelectorAll("[data-media-id]").forEach((e) => {
                e.classList.remove("is-active");
            }),
                this.setImageSetMedia(),
                t.classList.add("is-active"),
                t.parentElement.prepend(t),
                window.setTimeout(() => {
                    t.parentElement.scrollTo({ left: 0, top: 0, behavior: "smooth" });
                });
        }
        updateURL() {
            this.currentVariant && "false" !== this.dataset.updateUrl && window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
        }
        updateShareUrl() {
            const e = document.getElementById(`Share-${this.dataset.section}`);
            e && e.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
        }
        updateVariantInput() {
            document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`).forEach((e) => {
                const t = e.querySelector('input[name="id"]');
                (t.value = this.currentVariant.id), t.dispatchEvent(new Event("change", { bubbles: !0 }));
            });
        }
        updatePickupAvailability() {
            const e = document.querySelector(".pickup-availability-wrapper");
            e && (this.currentVariant && this.currentVariant.available ? e.fetchAvailability(this.currentVariant.id) : (e.removeAttribute("available"), (e.innerHTML = "")));
        }
        removeErrorMessage() {
            const e = this.closest("section");
            if (!e) return;
            const t = e.querySelector("product-form");
            t && t.handleErrorMessage();
        }
        getSectionsToRender() {
            return [
                `price-${this.dataset.section}`,
                `price-${this.dataset.section}--sticky`,
                `product-image-${this.dataset.section}--sticky`,
                `inventory-${this.dataset.section}`,
                `sku-${this.dataset.section}`,
                `quantity-${this.dataset.section}`,
            ];
        }
        renderProductInfo() {
            let e = this.getSectionsToRender();
            fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
                .then((e) => e.text())
                .then((t) => {
                    const i = new DOMParser().parseFromString(t, "text/html");
                    e.forEach((e) => {
                        const t = document.getElementById(e),
                            s = i.getElementById(e);
                        s && t && (t.innerHTML = s.innerHTML);
                        const r = document.getElementById(e),
                            a = document.getElementById(e + "--sticky");
                        r && r.classList.remove("visibility-hidden"), a && a.classList.remove("visibility-hidden");
                    }),
                        this.toggleAddButton(!this.currentVariant.available, window.theme.variantStrings.soldOut);
                });
        }
        toggleAddButton(e = !0, t = !1, i = !0) {
            if (!document.getElementById(`product-form-${this.dataset.section}`)) return;
            const s = document.querySelectorAll(".single-add-to-cart-button");
            s &&
                s.forEach((i) => {
                    const s = i.querySelector(".single-add-to-cart-button--text");
                    s && (e ? (i.setAttribute("disabled", "disabled"), t && (s.textContent = t)) : (i.removeAttribute("disabled"), i.classList.remove("loading"), (s.textContent = window.theme.variantStrings.addToCart)));
                });
        }
        setUnavailable() {
            const e = document.querySelectorAll(".single-add-to-cart-button"),
                t = document.getElementById(`price-${this.dataset.section}`),
                i = document.getElementById(`price-${this.dataset.section}--sticky`);
            e.forEach((e) => {
                const t = e.querySelector(".single-add-to-cart-button--text");
                e && ((t.textContent = window.theme.variantStrings.unavailable), e.classList.add("sold-out"));
            }),
                t && t.classList.add("visibility-hidden"),
                i && i.classList.add("visibility-hidden");
        }
        setDisabled() {
            if ("true" != this.isDisabledFeature) return;
            const e = this.getVariantData();
            if (e) {
                const t = this.currentVariant.options.map((e, t) => ({ value: e, index: `option${t + 1}` })),
                    i = this.createAvailableOptionsTree(e, t);
                this.fieldsets.forEach((e, t) => {
                    const s = Object.values(i)[t];
                    s &&
                        (e.querySelector("select")
                            ? s.forEach((t, i) => {
                                  t.isUnavailable ? (e.querySelector("option[value=" + JSON.stringify(t.value) + "]").disabled = !0) : (e.querySelector("option[value=" + JSON.stringify(t.value) + "]").disabled = !1);
                              })
                            : e.querySelectorAll("input").length &&
                              e.querySelectorAll("input").forEach((e, t) => {
                                  e.classList.toggle("is-disabled", s[t].isUnavailable);
                              }));
                });
            }
            return !0;
        }
        getImageSetName(e) {
            return e
                .toLowerCase()
                .replace(/[^a-z0-9]+/g, "-")
                .replace(/-$/, "")
                .replace(/^-/, "");
        }
        setImageSet() {
            if (!this.productSlider) return;
            let e = this.productSlider.querySelector("[data-set-name]");
            e && ((this.imageSetName = e.dataset.setName), (this.imageSetIndex = this.querySelector('.product-form__input[data-handle="' + this.imageSetName + '"]').dataset.index), this.setImageSetMedia());
        }
        setImageSetMedia() {
            if (!this.imageSetIndex) return;
            let e = this.getImageSetName(this.currentVariant[this.imageSetIndex]),
                t = this.imageSetName + "_" + e,
                i = this.productSlider.querySelectorAll(`[data-set-name="${this.imageSetName}"]`);
            if (this.hideVariants)
                i.forEach((e) => {
                    e.classList.toggle("is-active", e.dataset.group === t);
                });
            else {
                Array.from(i)
                    .filter(function (e) {
                        return e.dataset.group === t;
                    })
                    .forEach((e) => {
                        e.parentElement.prepend(e);
                    });
            }
        }
        createAvailableOptionsTree(e, t) {
            return e.reduce(
                (e, i) => (
                    Object.keys(e).forEach((s) => {
                        if (null === i[s]) return;
                        let r = e[s].find((e) => e.value === i[s]);
                        void 0 === r && ((r = { value: i[s], isUnavailable: !0 }), e[s].push(r));
                        const a = t.reduce((e, { value: t, index: s }) => (i[s] === t ? e + 1 : e), 0);
                        a >= t.length - 1 && (r.isUnavailable = (!r.isUnavailable || !i.available) && r.isUnavailable),
                            (this.currentVariant && this.currentVariant.available) || !t.find((e) => e.value === r.value && s === e.index) || (r.isUnavailable = !0),
                            "option1" === s && (r.isUnavailable = (!r.isUnavailable || !i.available) && r.isUnavailable);
                    }),
                    e
                ),
                { option1: [], option2: [], option3: [] }
            );
        }
        getVariantData() {
            return (this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent)), this.variantData;
        }
    }
    customElements.define("variant-selects", e);
    class t extends e {
        constructor() {
            super();
        }
        updateOptions() {
            const e = Array.from(this.querySelectorAll("fieldset"));
            this.options = e.map((e) => Array.from(e.querySelectorAll("input")).find((e) => e.checked).value);
        }
    }
    customElements.define("variant-radios", t);
}
if (!customElements.get("product-slider")) {
    class e extends HTMLElement {
        constructor() {
            super();
        }
        connectedCallback() {
            if (
                ((this.pagination = this.parentElement.querySelector(".product-images-buttons")),
                (this.sliderItems = this.querySelectorAll('[id^="Slide-"]')),
                new MutationObserver(() => {
                    this.setupProductGallery();
                }).observe(this, { attributes: !0, attributeFilter: ["class"], childList: !0, characterData: !1 }),
                this.setupProductGallery(),
                this.pagination)
            ) {
                this.setupPagination(), this.addEventListener("scroll", this.updatePagination.bind(this));
                new ResizeObserver((e) => this.onPaginationResize()).observe(this);
            }
        }
        setupProductGallery() {
            this.querySelectorAll(".product-single__media-zoom").length && this.setEventListeners();
        }
        buildItems(e) {
            return e.map((e) => {
                let t = e.querySelector(".product-single__media-zoom");
                return { src: t.getAttribute("href"), msrc: t.dataset.msrc, w: t.dataset.w, h: t.dataset.h, title: t.getAttribute("title") };
            });
        }
        setEventListeners() {
            let e = Array.from(this.querySelectorAll(".product-images__slide--image")).filter((e) => e.clientWidth > 0),
                t = this.buildItems(e),
                i = this.dataset.captions,
                s = document.querySelectorAll(".pswp")[0],
                r = {
                    maxSpreadZoom: 2,
                    loop: !1,
                    allowPanToNext: !1,
                    closeOnScroll: !1,
                    showHideOpacity: !1,
                    arrowKeys: !0,
                    history: !1,
                    captionEl: i,
                    fullscreenEl: !1,
                    zoomEl: !1,
                    shareEl: !1,
                    counterEl: !0,
                    arrowEl: !0,
                    preloaderEl: !0,
                };
            this.querySelectorAll(".product-single__media-zoom").forEach(function (i) {
                let a = i.closest(".product-single__media"),
                    n = i.cloneNode(!0);
                a.append(n),
                    i.remove(),
                    n.addEventListener("click", (i) =>
                        (function (t, i, s, r, a) {
                            let n = i.closest(".product-images__slide"),
                                o = e.indexOf(n);
                            if (
                                ((s.index = parseInt(o, 10)),
                                (s.getThumbBoundsFn = () => {
                                    const e = i.closest(".product-single__media"),
                                        t = window.scrollY || document.documentElement.scrollTop,
                                        s = e.getBoundingClientRect();
                                    return { x: s.left, y: s.top + t, w: s.width };
                                }),
                                "undefined" != typeof PhotoSwipe)
                            ) {
                                let e = new PhotoSwipe(r, PhotoSwipeUI_Default, a, s);
                                e.listen("firstUpdate", () => {
                                    e.listen("parseVerticalMargin", function (e) {
                                        e.vGap = { top: 50, bottom: 50 };
                                    });
                                }),
                                    e.init();
                            }
                            t.preventDefault();
                        })(i, n, r, s, t)
                    );
            });
        }
        setupPagination() {
            (this.sliderItemsToShow = Array.from(this.sliderItems).filter((e) => e.clientWidth > 0)),
                this.sliderItemsToShow.length < 2 ||
                    ((this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft),
                    (this.currentPageElement = this.pagination.querySelector(".slider-counter--current")),
                    (this.pageTotalElement = this.pagination.querySelector(".slider-counter--total")),
                    (this.prevButton = this.pagination.querySelector('button[name="previous"]')),
                    (this.nextButton = this.pagination.querySelector('button[name="next"]')),
                    this.prevButton.addEventListener("click", this.onPaginationButtonClick.bind(this)),
                    this.nextButton.addEventListener("click", this.onPaginationButtonClick.bind(this)),
                    this.updatePagination());
        }
        onPaginationResize() {
            (this.sliderItemsToShow = Array.from(this.sliderItems).filter((e) => e.clientWidth > 0)),
                this.sliderItemsToShow.length < 2 || (this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft);
        }
        onPaginationButtonClick(e) {
            e.preventDefault(), (this.slideScrollPosition = "next" === e.currentTarget.name ? this.scrollLeft + 1 * this.sliderItemOffset : this.scrollLeft - 1 * this.sliderItemOffset), this.scrollTo({ left: this.slideScrollPosition });
        }
        updatePagination() {
            if (!this.nextButton) return;
            const e = this.currentPage;
            if (((this.currentPage = Math.round(this.scrollLeft / this.sliderItemOffset) + 1), this.currentPageElement && (this.currentPageElement.textContent = this.currentPage), this.currentPage != e)) {
                this.dispatchEvent(new CustomEvent("slideChanged", { detail: { currentPage: this.currentPage, currentElement: this.sliderItemsToShow[this.currentPage - 1] } }));
                var t = this.currentPage;
                document.querySelectorAll(".slider-thumbs .slick-slide").forEach((e) => {
                    e.classList.remove("active");
                }),
                    document.querySelectorAll(".slider-thumbs .slick-slide").forEach((e, i) => {
                        t == i + 1 ? (e.classList.add("slick-current"), e.classList.add("active")) : (e.classList.remove("slick-current"), e.classList.remove("active"));
                    });
            }
            this.isSlideVisible(this.sliderItemsToShow[0]) && 0 === this.scrollLeft ? this.prevButton.setAttribute("disabled", "disabled") : this.prevButton.removeAttribute("disabled"),
                this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1]) ? this.nextButton.setAttribute("disabled", "disabled") : this.nextButton.removeAttribute("disabled");
        }
        isSlideVisible(e, t = 0) {
            const i = this.clientWidth + this.scrollLeft - t;
            return e.offsetLeft + e.clientWidth <= i && e.offsetLeft >= this.scrollLeft;
        }
    }
    customElements.define("product-slider", e);
}
if (
    (customElements.get("product-form") ||
        customElements.define(
            "product-form",
            class extends HTMLElement {
                constructor() {
                    super(),
                        (this.sticky = this.dataset.sticky),
                        (this.form = document.getElementById(`product-form-${this.dataset.section}`)),
                        (this.form.querySelector("[name=id]").disabled = !1),
                        this.sticky || this.form.addEventListener("submit", this.onSubmitHandler.bind(this)),
                        (this.cartNotification = document.querySelector("cart-notification")),
                        (this.body = document.body),
                        (this.hideErrors = "true" === this.dataset.hideErrors);
                }
                onSubmitHandler(e) {
                    if ((e.preventDefault(), !this.form.reportValidity())) return;
                    const t = document.querySelectorAll(".single-add-to-cart-button");
                    t.forEach((e) => {
                        e.classList.contains("loading") || (e.setAttribute("aria-disabled", !0), e.classList.add("loading"));
                    }),
                        this.handleErrorMessage();
                    const i = { method: "POST", headers: { "X-Requested-With": "XMLHttpRequest", Accept: "application/javascript" } };
                    let s = new FormData(this.form);
                    s.append(
                        "sections",
                        this.getSectionsToRender().map((e) => e.section)
                    ),
                        s.append("sections_url", window.location.pathname),
                        (i.body = s),
                        fetch(`${theme.routes.cart_add_url}`, i)
                            .then((e) => e.json())
                            .then((e) => {
                                if (e.status)
                                    return dispatchCustomEvent("product:variant-error", { source: "product-form", productVariantId: s.get("id"), errors: e.description, message: e.message }), void this.handleErrorMessage(e.description);
                                this.renderContents(e), dispatchCustomEvent("cart:item-added", { product: e.hasOwnProperty("items") ? e.items[0] : e });
                            })
                            .catch((e) => {
                                console.error(e);
                            })
                            .finally(() => {
                                t.forEach((e) => {
                                    e.classList.remove("loading"), e.removeAttribute("aria-disabled");
                                });
                            });
                }
                getSectionsToRender() {
                    return [
                        { id: "Cart", section: "main-cart", selector: ".thb-cart-form" },
                        { id: "Cart-Drawer", section: "cart-drawer", selector: ".cart-drawer" },
                        { id: "cart-drawer-toggle", section: "cart-bubble", selector: ".thb-item-count" },
                    ];
                }
                getCookie(e) {
                    let t = document.cookie.match(new RegExp("(?:^|; )" + e.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") + "=([^;]*)"));
                    return t ? decodeURIComponent(t[1]) : void 0;
                }
                setCookie(e, t, i = {}) {
                    (i = { path: "/" }).expires instanceof Date && (i.expires = i.expires.toUTCString());
                    let s = encodeURIComponent(e) + "=" + encodeURIComponent(t);
                    for (let e in i) {
                        s += "; " + e;
                        let t = i[e];
                        !0 !== t && (s += "=" + t);
                    }
                    document.cookie = s;
                }
                deleteCookie(e) {
                    setCookie(e, "", { "max-age": -1 });
                }
                initCartDiscount(e) {
                    let t = e.querySelectorAll(".span_tips");
                    for (let i = 0; i < t.length; i++) {
                        let s = t[i].dataset.type,
                            r = e.querySelector("." + s);
                        (r.style.top = "-" + r.offsetHeight + "px"),
                            t[i].addEventListener("mouseenter", (e) => {
                                (r.style.opacity = 1), (r.style.zIndex = 1);
                            }),
                            t[i].addEventListener("mouseleave", (e) => {
                                (r.style.opacity = 0), (r.style.zIndex = 1);
                            });
                    }
                }
                renderContents(e) {
                    this.getSectionsToRender().forEach((t) => {
                        if (!document.getElementById(t.id)) return;
                        const i = document.getElementById(t.id).querySelector(t.selector) || document.getElementById(t.id);
                        if ("Cart-Drawer" == t.id) {
                            let s = this.getCookie("side-panel-discount-product-free-shipping"),
                                r = this.getCookie("side-panel-discount-product-rush-order");
                            "check" != s &&
                                (e.sections["cart-drawer"] = e.sections["cart-drawer"].replace(
                                    '<input type="checkbox" name="side-panel-discount-product-free-shipping" checked="checked"',
                                    '<input type="checkbox" name="side-panel-discount-product-free-shipping" '
                                )),
                                "check" != r &&
                                    (e.sections["cart-drawer"] = e.sections["cart-drawer"].replace(
                                        '<input type="checkbox" name="side-panel-discount-product-rush-order" checked="checked"',
                                        '<input type="checkbox" name="side-panel-discount-product-rush-order" '
                                    )),
                                (i.innerHTML = this.getSectionInnerHTML(e.sections[t.section], t.selector)),
                                this.initCartDiscount(i);
                        } else i.innerHTML = this.getSectionInnerHTML(e.sections[t.section], t.selector);
                        "undefined" != typeof CartDrawer && new CartDrawer(), "undefined" != typeof Cart && new Cart().renderContents(e);
                    });
                    let t = document.getElementById("Product-Drawer");
                    t && t.contains(this)
                        ? (t.querySelector(".product-quick-images--container").classList.remove("active"),
                          document.body.classList.remove("open-quick-view"),
                          window.innerWidth < 1069
                              ? (t.classList.remove("active"),
                                document.getElementById("Cart-Drawer") &&
                                    (document.getElementById("Cart-Drawer").classList.add("active"),
                                    document.body.classList.add("open-cart"),
                                    document.getElementById("Cart-Drawer").querySelector(".product-recommendations--full").classList.add("active"),
                                    dispatchCustomEvent("cart-drawer:open")))
                              : t.querySelector(".product-quick-images--container").addEventListener("transitionend", function () {
                                    t.classList.remove("active"),
                                        document.getElementById("Cart-Drawer") &&
                                            (document.getElementById("Cart-Drawer").classList.add("active"),
                                            document.body.classList.add("open-cart"),
                                            document.getElementById("Cart-Drawer").querySelector(".product-recommendations--full").classList.add("active"),
                                            dispatchCustomEvent("cart-drawer:open"));
                                }),
                          document.getElementById("Cart-Drawer") || document.body.classList.remove("open-cc"))
                        : document.getElementById("Cart-Drawer") &&
                          (document.body.classList.add("open-cc"), document.body.classList.add("open-cart"), document.getElementById("Cart-Drawer").classList.add("active"), dispatchCustomEvent("cart-drawer:open"));
                }
                getSectionInnerHTML(e, t = ".shopify-section") {
                    return new DOMParser().parseFromString(e, "text/html").querySelector(t).innerHTML;
                }
                handleErrorMessage(e = !1) {
                    this.hideErrors ||
                        ((this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper")),
                        (this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message")),
                        this.errorMessageWrapper.toggleAttribute("hidden", !e),
                        e && (this.errorMessage.textContent = e));
                }
            }
        ),
    !customElements.get("product-add-to-cart-sticky"))
) {
    class e extends HTMLElement {
        constructor() {
            super(), (this.animations_enabled = document.body.classList.contains("animations-true") && "undefined" != typeof gsap);
        }
        connectedCallback() {
            this.setupObservers(), this.setupToggle();
        }
        setupToggle() {
            const e = this.querySelector(".product-add-to-cart-sticky--inner"),
                t = this.querySelector(".product-add-to-cart-sticky--content");
            if (this.animations_enabled) {
                const i = gsap.timeline({
                    reversed: !0,
                    paused: !0,
                    onStart: () => {
                        e.classList.add("sticky-open");
                    },
                    onReverseComplete: () => {
                        e.classList.remove("sticky-open");
                    },
                });
                i.set(t, { display: "block", height: "auto" }, "start").from(t, { height: 0, duration: 0.25 }, "start+=0.001"),
                    e.addEventListener("click", function () {
                        return i.reversed() ? i.play() : i.reverse(), !1;
                    });
            } else
                e.addEventListener("click", function () {
                    return t.classList.toggle("active"), !1;
                });
        }
        setupObservers() {
            let e = this,
                t = new IntersectionObserver(
                    function (t) {
                        t.forEach((t) => {
                            if ((t.target === s && (t.intersectionRatio > 0 ? e.classList.remove("sticky--visible") : 0 == t.intersectionRatio && e.formPassed && e.classList.add("sticky--visible")), t.target === i)) {
                                let s = i.getBoundingClientRect();
                                0 === t.intersectionRatio && window.scrollY > s.top + s.height
                                    ? ((e.formPassed = !0), e.classList.add("sticky--visible"))
                                    : 1 === t.intersectionRatio && ((e.formPassed = !1), e.classList.remove("sticky--visible"));
                            }
                        });
                    },
                    { threshold: [0, 1] }
                ),
                i = document.getElementById(`product-form-${this.dataset.section}`),
                s = document.getElementById("footer");
            (e.formPassed = !1), t.observe(i), t.observe(s);
        }
    }
    customElements.define("product-add-to-cart-sticky", e);
}
if (!customElements.get("side-panel-links")) {
    class e extends HTMLElement {
        constructor() {
            super(),
                (this.links = this.querySelectorAll("button")),
                (this.drawer = document.getElementById("Product-Information-Drawer")),
                (this.buttons = this.drawer.querySelector(".side-panel-content--tabs")),
                (this.panels = this.drawer.querySelector(".side-panel-content--inner").querySelectorAll(".side-panel-content--tab-panel")),
                (this.body = document.body);
        }
        connectedCallback() {
            this.setupObservers();
        }
        disconnectedCallback() {}
        setupObservers() {
            this.links.forEach((e, t) => {
                e.addEventListener("click", (e) => {
                    this.body.classList.add("open-cc"), this.buttons.toggleActiveClass(t), this.drawer.classList.add("active");
                });
            });
        }
    }
    customElements.define("side-panel-links", e);
}
"undefined" != typeof addIdToRecentlyViewed && addIdToRecentlyViewed();
